import Resource from './resource'
import OrderableGame from './orderable-game'

export default class OrderItem extends Resource {
  constructor ({ attrs = {}, ...params }) {
    super({ attrs, ...params })

    this.data.orderable = OrderItem.mapOrderable({ type: attrs.orderableType, attrs: attrs.orderable, parent: this })
    this.data.orderableStore = this.data.orderableStore || {}
  }

  get root () {
    if (this._root) return this._root
    if (this._parent) this._root = `${this._parent.resourcePath}/items`

    return this._root
  }

  get asJson () {
    const json = super.asJson

    json.orderableAttributes = json.orderable?.asJson || json.orderableAttributes
    json.orderableId = json.orderableAttributes?.id || json.orderableId
    json.orderableType = json.orderableAttributes?.type || json.orderableType
    delete json.orderable

    return json
  }

  static mapOrderable ({ type, attrs, parent }) {
    if (type === 'Game') {
      return new OrderableGame({ attrs, parent })
    }

    return new Resource({ attrs, parent })
  }
}

OrderItem.paramName = 'order_item'
